//NEW: UI_REVAMP
import { Box } from '@chakra-ui/react';
import ImgComp from '../../utils/ImgComp';

const Logo = () => {
	return (
		<Box
			boxSize={{ base: '32px', lg: '46px' }}
			borderRadius='full'
			p={{ base: '1.14px', lg: '1.64px' }}
			bgGradient='linear(180deg,#F5D7A9,#E28E10,#E3CA89,#E2A74C,#4D3A1A,#F5D7A9)'
			display='flex'
			alignItems='center'
			justifyContent='center'
		>
			<Box
				boxSize='full'
				bg='white'
				borderRadius='full'
				display='flex'
				alignItems='center'
				justifyContent='center'
				p={{ base: '2px', lg: '3px' }}
			>
				<ImgComp svgName='logo' w='full' h='full' />
			</Box>
		</Box>
	);
};

export default Logo;
